<template>
  <div class="converted-bid" v-if="!isCurrencyBase && currentBid">
    <span class="converted-amount">
      {{ selectedCurrency ? formatCurrency(currentBid * selectedCurrency.rate) : '~' }} {{ currency }}
    </span>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { format_currency } from "@/utils/currencies";

  const auctionStore = useAuctionStore();
  const currentBid = computed(() => auctionStore.activeLot.current_bid);
  const currency = computed(() => auctionStore.currency);
  const isCurrencyBase = computed(() => auctionStore.isCurrencyBase);
  const currencies = computed(() => auctionStore.currencies);
  const selectedCurrency = computed(() => currencies.value.find(item => item.abbr === currency.value));

  const formatCurrency = (amount: number) => {
    return format_currency(amount, "");
  }
</script>
